import { AsyncPipe } from "@angular/common";
import { Component, inject, NgZone, OnDestroy, OnInit, signal, ViewChild } from "@angular/core";
import { doc, docData, Firestore, getDoc } from "@angular/fire/firestore";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { combineLatest, from, Observable, of, Subscription, throwError } from "rxjs";
import { catchError, finalize, map, switchMap, take } from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { WalletService } from "src/app/pages/account/account-wallet/wallet.services";
import { CommonService } from "src/app/services/common/common.service";
import { GameBalanceService } from "src/app/services/game-balance.service";
import { GTMSagmentService } from "src/app/services/gtm-sagment.service";
import { SliderManagerService } from "src/app/services/slider-manager.service";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { AutoRefreshDialogComponent } from "../auto-refresh-dialog/auto-refresh-dialog.component";
import { MyToastbarComponent } from "../my-toastbar/my-toastbar.component";
import { ClarityService } from "src/app/services/clarity.service";
declare var window;
declare var localStorage: Storage;

@Component({
  selector: "app-store-top-up",
  templateUrl: "./store-top-up.component.html",
  styleUrls: ["./store-top-up.component.scss"],
  standalone: true,
  imports: [
    SwiperModule,
    IonicModule,
    MatIcon,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class StoreTopUpComponent implements OnInit, OnDestroy {
  selectedLanguage: string = CommonVariable?.preferredLanguage;
  translatedToastMsg: Data;
  topupData: any;
  creditRefresh: Data;
  credit_refresh_input: Data;
  credit_refresh_output: Data;
  low_trigger_threshold: Data;
  credit_currency: number;
  showTicket: boolean;
  public selectedCard: number;
  paymentcard: boolean;
  descIndex: number;
  public tenticektNumber: number;
  public zeroNumber: number;
  public IsActiveAutoRefresh: boolean;
  public btnTxt: boolean;
  gift_Desc: string;
  public autoTopUpActionInProgress: boolean = false;
  isCreditRefresh = signal<boolean>(false);
  topupSliderSubscription: Subscription;
  storedCardsSubscription: Subscription;
  syndicatePromoSubscription: Subscription;
  promoName: string;
  public userId: string;
  @ViewChild("creditData") public creditData: SwiperComponent;
  private clarityService = inject(ClarityService);
  topupThresholdValue = 0.5;
  public onSlideChange() {
    this.selectedCard = this.creditData?.swiperRef?.activeIndex;
    // Passed selected card index to CTA
    this.changedCTA(this.selectedCard);
  }

  creditDefault = getDoc(doc(this.firestore, 'general_modules/system_reference')).then((res) => {
    const data = res?.data();

    this.credit_refresh_input = data?.credit_refresh_input;
    this.credit_refresh_output = data?.credit_refresh_output;
    this.low_trigger_threshold = data?.low_trigger_threshold;
    return data;
  }).catch((error) => {
    console.error('[creditDefault] Error fetching Firestore document:', error);
  });

  preferredCurrency: string = CommonVariable.preferredCurrency;
  currencySymbol: string;
  checkCardsAndCredit: boolean;

  Cardcurrency$ = this.authService.$CardData.subscribe();

  currency$: Observable<any> = this.commonService.getUid("").pipe(
    switchMap((uid: string) => {
      if (!uid) return of(null);

      const userDocRef = doc(this.firestore, `users/${uid}/balance/current`);
      return docData(userDocRef).pipe(
        map((data: any) => {
          this.credit_currency = data?.preferred_currency?.credit ?? data?.credit;
          return data;
        })
      );
    })
  );



  userDetails$: Observable<any> = this.commonService.getUid("").pipe(
    switchMap((uid: string) =>
      docData(doc(this.firestore, `users/${uid}`))
    ),
    map((data: any) => {
      this.paymentcard = data?.token_exists;
      return data;
    })
  );

  topUpData$ = combineLatest([
    from(getDoc(doc(this.firestore, 'Global_lookup/credit_top_up_new_currency'))),
    this.gameBalanceService.isCreditRefresh$,
    this.authService.userCurrentBalance$,
    this.walletService.storedCards$
  ]).pipe(
    take(1),
    map(async ([docSnap, inAppNotification, stored_card]: any[]) => {
      this.creditRefresh = inAppNotification;

      const data = docSnap.exists() ? docSnap.data()?.options as Data[] : [];
      localStorage.setItem("InAppNotification", inAppNotification?.status);

      if (stored_card?.length > 0) {
        this.checkCardsAndCredit = true;
        if (inAppNotification?.status) {
          this.IsActiveAutoRefresh = true;
          data?.forEach((m, index) => {
            const amountCredit = m?.int_amount_credit ?? m?.amount_credit;
            if (amountCredit && index === 1) {
              m.hide = false;
              m.show_default = true;
              this.previousCheckedCard = index;
            } else if (this.paymentcard && amountCredit) {
              if (index === 0) m.hide = false;
              if (index === 3) m.hide = true;
              if (index === 2) {
                m.hide = false;
                this.descIndex = index;
              }
              m.show_default = false;
            }
          });
        } else {
          this.IsActiveAutoRefresh = false;
          data?.forEach((m, index) => {
            const amountCredit = m?.int_amount_credit ?? m?.amount_credit;
            if (amountCredit) {
              m.hide = index !== 1;
              m.show_default = index === 2;
              if (index === 2) this.descIndex = index;
            }
          });
        }
      } else {
        this.checkCardsAndCredit = false;
        data?.forEach((m, index) => {
          const amountCredit = m?.int_amount_credit ?? m?.amount_credit;
          if (index === 1) {
            m.hide = false;
            m.show_default = true;
            this.previousCheckedCard = index;
          }
          if (!this.paymentcard && amountCredit) {
            if (index === 3) m.hide = false;
            if (index === 2) {
              m.hide = true;
              this.descIndex = index;
            }
          } else if (this.paymentcard && this.credit_currency === this.zeroNumber) {
            m.hide = index === 2;
            m.show_default = index === 1;
            if (index === 2) this.descIndex = index;
          }
        });
      }

      this.topupData = data;

      for (const ele of this.topupData) {
        const descriptions = ele?.content?.descriptionTr?.[this.selectedLanguage] || ele?.content?.description;
        const intDescription: any[] = [];


        if (descriptions?.length) {
          await Promise.all(descriptions.map(async (desc, index) => {
            try {
              this.authService.currencyNodeDvData = ele
              const dvString = await this.authService.getDVFromString(desc);
              intDescription[index] = dvString || '';
            } catch (err) {
              intDescription[index] = '';
              console.error(`Error resolving DV string for description: ${desc}`, err);
            }
          }));
          ele["int_description"] = intDescription;
          this.authService.currencyNodeDvData = ele;
        }

        const checkoutDetails = ele?.content?.int_checkout_details?.[this.selectedLanguage] || ele?.content?.checkout_details;
        if (checkoutDetails) {
          try {
            const dvCheckout = await this.authService.getDVFromString(checkoutDetails);
            ele["checkout_details"] = dvCheckout || '';
          } catch (err) {
            console.error("Checkout details DV error:", err);
          }
          this.authService.currencyNodeDvData = ele;
        }
      }

      const selectedLanguageOrDefault = this.selectedLanguage || 'en';
      const giftDescription = data[2]?.content?.gift_descriptionTr?.[selectedLanguageOrDefault] || data[2]?.content?.gift_description;

      this.gift_Desc = giftDescription
        ? giftDescription.replace(
          "[currency_node:gift]",
          this.currencySymbol + (data[2]?.int_gift?.[this.preferredCurrency] || "")
        )
        : "";

      if (data?.length > 0) {
        setTimeout(() => this.slideTopupCard(), 1000);
      }

      this.topupData.sort((a, b) => {
        const aHasThreshold = 'threshold' in a;
        const bHasThreshold = 'threshold' in b;

        if (aHasThreshold && !bHasThreshold) return -1;
        if (!aHasThreshold && bHasThreshold) return 1;
        return (aHasThreshold && bHasThreshold) ? a.price - b.price : b.price - a.price;
      });

      if (this.creditRefresh?.status && Array.isArray(this.topupData)) {
        this.topupData = [...this.topupData.slice(1), this.topupData[0]];
      }

      return data;
    }),
    switchMap(p => from(p)) // unwrap the async map result
  );

  slideTopupCard() {
    const totalSlides = this.creditData?.swiperRef?.slides?.length;
    this.topupSliderSubscription = this.sliderManagerService.currentSlideData.pipe(
      take(1)
    ).subscribe(
      (data) => {
        if (!data) return;

        let slideIndex: number;
        switch (data) {
          case "credit-5":
            slideIndex = this.getSpecificIndex(5) ?? (totalSlides === 4 ? 3 : 2);
            break;

          case "credit-10":
            slideIndex = this.getSpecificIndex(10) ?? (totalSlides === 4 ? 2 : 1);
            break;

          case "auto-refresh":
            if (totalSlides === 4) {
              slideIndex = this.getSpecificIndex(6) ?? 0;
            }
            break;

          case "credit-15":
            slideIndex = this.getSpecificIndex(15) ?? (totalSlides === 4 ? 1 : 0);
            break;

          default:
            slideIndex = 0;
            break;
        }

        if (slideIndex !== undefined) {
          this.goToSlide(slideIndex);
        }
      },
      (err) => {
        this.changedCheck(2);
        return err;
      }
    );
  }
  private previousCheckedCard: number;
  constructor(
    private firestore: Firestore,
    private matDialog: MatDialog,
    private bottomSheetRef: MatBottomSheetRef<StoreTopUpComponent>,
    public translate: TranslateService,
    private authService: AuthService,
    private GTMSegment: GTMSagmentService,
    private accountService: AccountRepositoryService,
    private snackBar: MatSnackBar,
    private walletService: WalletService,
    private sliderManagerService: SliderManagerService,
    private router: Router,
    private gameBalanceService: GameBalanceService,
    private ngZone: NgZone,
    private commonService: CommonService
  ) {
    this.previousCheckedCard = 3;
    this.showTicket = true;
    this.descIndex = 2;
    this.zeroNumber = 0;
    this.currencySymbol = "£";
    this.checkCardsAndCredit = false;
    this.walletService.isAccountPage = true;
    this.GTMSegment.GTMPopupInitialization("StoreTopUp");
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService.getConstantsMsg$.subscribe((msg: Data) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });

    this.authService.userDetails$.subscribe(
      (user: Data) => {
        this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
        this.authService.getCurrencyList$.subscribe((data: Data) => {
          const CurrencyDetails = data?.details?.find((x: Data) => x?.currency_code === this.preferredCurrency);
          this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
        });
      },
      (err) => {
        return err;
      }
    );
    // This method is used to check if credit card is refreshed or not
    this.gameBalanceService.isCreditRefresh$.subscribe((data: Data) => {
      const isCreditValue = data === null ? true : false;
      this.isCreditRefresh.set(isCreditValue);
    });
    this.promoName = localStorage.getItem("engagement_promo");
  }

  async ngOnInit() {
    await this.authService.getUid("StoreTopUpComponent").then((uid) => {
      this.userId = uid;
    })
    this.callPromoCF("seen");
  }

  sliderOptions: SwiperOptions = {
    initialSlide: 0,
    speed: 400,
    slidesPerView: 1.25,
    spaceBetween: 1,
    centeredSlides: true,
    pagination: {
      clickable: true, // Enable clickable pagination
    },
    slideToClickedSlide: true, // Enable click-to-slide functionality
    breakpoints: {
      768: {
        slidesPerView: 1.5, // Show 3 slides on screens wider than 768px
      },
    },
  };

  // Changes the CTA text based on the threshold
  changedCTA(index: number) {
    let data = this.topupData[index];
    if (!data.threshold) {
      this.btnTxt = true;
    } else {
      this.btnTxt = false;
    }
  }

  changedCheck(index) {
    this.topupData[index].show_default = true;
    if (this.paymentcard == true && index == 2) {
      this.topupData[0].hide = true;
      this.topupData[3].hide = false;
      this.topupData[3].show_default = false;
    }

    if (this.paymentcard == true && index == 1) {
      this.topupData[3].hide = true;
      this.topupData[0].hide = false;
      this.topupData[0].show_default = false;
      this.topupData[2].show_default = false;
    }

    if (this.paymentcard == true && index == 3) {
      this.topupData[0].hide = true;
      this.topupData[2].show_default = false;
      this.topupData[1].show_default = false;
    }
    this.topupData[this.previousCheckedCard].show_default = false;
    this.topupData[index].show_default = true;
    this.previousCheckedCard = index;
    return true;
  }

  changedAutoRefreshCheck(index) {
    this.topupData[index].show_default = false;
    this.topupData[index].hide = true;
    this.topupData[1].show_default = true;
    this.previousCheckedCard = index;

    // this.authService.changeStatus(this.topupData).then((res) => {

    // });
  }

  navigateToCheckout() {
    if (this.autoTopUpActionInProgress) {
      return;
    }

    const index = this.selectedCard;
    const topup = this.topupData[index];
    const btnTxt = this.getButtonText(topup, this.creditRefresh);

    this.callPromoCF("click");

    if (btnTxt === "Turn off auto refresh") {
      const decline = this.matDialog.open(AutoRefreshDialogComponent, {
        panelClass: "ongoingWarning-size",
        backdropClass: "ongoingWarning-back-drop-color",
        data: topup,
      });

      decline
        .afterClosed()
        .pipe(take(1))
        .subscribe(() => {
          this.topupData = this.topupData.map((ele, i) => {
            if (i === index) {
              ele.hide = true;
              ele.show_default = false;
            }
            return ele;
          });

          this.bottomSheetRef.dismiss();
        });
      return;
    }

    if (btnTxt !== "Turn on auto refresh") {
      this.bottomSheetRef.dismiss(topup);
      return;
    }

    this.autoTopUpActionInProgress = true;
    this.storedCardsSubscription?.unsubscribe();

    let activationStarted = false;
    this.storedCardsSubscription = this.walletService.storedCards$
      .pipe(
        take(1),
        finalize(() => {
          if (!activationStarted) {
            this.releaseAutoTopUpActionLock();
          }
        })
      )
      .subscribe({
        next: (stored_card: Data) => {
          const storedCardCount = stored_card?.length ?? 0;

          if (storedCardCount <= 0) {
            this.bottomSheetRef.dismiss(topup);
            return;
          }

          activationStarted = true;
          this.submitAutoTopUpActivation(index);
        },
        error: (error) => {
	this.authService.errorHandlerLogs("[navigateToCheckout] Failed to read stored cards:", error);
        },
      });
  }

  ngOnDestroy(): void {
    this.releaseAutoTopUpActionLock();
    this.storedCardsSubscription?.unsubscribe();
    this.syndicatePromoSubscription?.unsubscribe();
  }

  private releaseAutoTopUpActionLock(): void {
    this.autoTopUpActionInProgress = false;
  }

  private submitAutoTopUpActivation(index: number): void {
    const cerditAmount: Data = {
      credit_refresh_input: this.credit_refresh_input,
      credit_refresh_output: this.credit_refresh_output,
      low_trigger_threshold: this.low_trigger_threshold,
    };

    this.syndicatePromoSubscription?.unsubscribe();
    this.syndicatePromoSubscription = this.accountService.syndicatePromotion$
      .pipe(
        take(1),
        switchMap((res) => {
          if (res) {
            cerditAmount["call_from"] = "auto_topup_promotion";
          }
          return this.authService.creditAutoRefresh(cerditAmount);
        }),
        catchError((error) => throwError(() => error)),
        finalize(() => {
          this.releaseAutoTopUpActionLock();
          this.bottomSheetRef.dismiss();
        })
      )
      .subscribe({
        next: (res: Data) => {
          if (res?.status === "rejected") {
            this.authService
              .getConstantsMsg(res?.error_code)
              .then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Something went wrong!",
                    line_2: "",
                  },
                  style: {
                    type: CommonVariable.error,
                    icon: "tick circle error.svg",
                  },
                };
                this.ngZone.run(() => {
                  this.authService.showToastMessage(translatedMsg, defaultMsg);
                });
              })
              .catch((error) => error);
            return;
          }

          this.authService.turnOnCreditRefresh();
          this.callPromoCF("conversion");
          this.clarityService.event("auto_topup_activated");

          const msgCode = this.creditRefresh == null ? "1060" : "1075";

          this.authService
            .getConstantsMsg(msgCode)
            .then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: msgCode === "1060" ? "Auto Refresh turned on" : "Credit Auto Refresh turned on",
                  line_2: msgCode === "1060" ? "You've also been awarded 1.50 Credit" : "",
                },
                style: {
                  icon: "tick circle success.png",
                  type: CommonVariable.success,
                },
              };
              this.ngZone.run(() => {
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              });
            })
            .catch((error) => error);

          this.topupData = this.topupData.map((ele, i) => {
            if (i === index) {
              ele.hide = true;
              ele.show_default = false;
            }
            return ele;
          });
        },
        error: (error) => {
	  this.authService.errorHandlerLogs("[submitAutoTopUpActivation] Final subscription error:", error);
        },
      });
  }

  getButtonText(topUp: Data, credit_refresh: Data) {
    // const index= this.selectedCard;
    // const topUp=this.topupData[index];
    if (!topUp.threshold) {
      return "Top up now";
    } else {
      /* 
            if (typeof topUp.amount_credit == 'string' && credit_refresh == null) {
              return "Turn on auto refresh";
            }
      
            if (typeof topUp.amount_credit == 'number' && credit_refresh == null) {
              return "Top up now"
            }
      
            if (credit_refresh?.status == false && typeof topUp.amount_credit == 'number') {
              return "Top up now"
            }
            if (credit_refresh?.status == false || credit_refresh?.status == null) {
              return "Turn on auto refresh";
            }
            return topUp && topUp.amount_credit && typeof topUp.amount_credit == "string"
              ? "Turn off auto refresh"
              : "Top up now"; */

      if (topUp.threshold == this.topupThresholdValue && credit_refresh == null) {
        return "Turn on auto refresh";
      }

      if (
        typeof topUp.amount_credit == "number" &&
        credit_refresh == null &&
        topUp.threshold !== this.topupThresholdValue
      ) {
        return "Top up now";
      }

      if (
        credit_refresh?.status == false &&
        typeof topUp.amount_credit == "number" &&
        topUp.threshold !== this.topupThresholdValue
      ) {
        return "Top up now";
      }
      if (credit_refresh?.status == false || credit_refresh?.status == null) {
        return "Turn on auto refresh";
      }
      return topUp && topUp.amount_credit && topUp.threshold == this.topupThresholdValue
        ? "Turn off auto refresh"
        : "Top up now";
    }
  }

  getType(topup) {
    if (topup.threshold === this.topupThresholdValue) {
      /* typeof topup.amount_credit == "string" */
      return true;
    } else {
      return false;
    }
  }

  showToast(message, snackType, description) {
    this.snackBar.openFromComponent(MyToastbarComponent, {
      duration: 5000,
      horizontalPosition: "center",
      verticalPosition: "top",
      panelClass: "toast-for-syndicate",
      data: { message: message, state: snackType, description: description },
    });
  }

  ionViewWillLeave() {
    this.storedCardsSubscription?.unsubscribe();
    this.topupSliderSubscription?.unsubscribe();
    this.sliderManagerService.currentSlideData.next("");
    this.syndicatePromoSubscription?.unsubscribe();
  }

  private goToSlide(index: number): void {
    if (!this.creditData || !this.creditData.swiperRef) return;
    this.creditData.swiperRef.slideTo(index);
  }

  private getSpecificIndex(index: number | string): number {
    const defaultIndex = 0;
    const specificIndex = this.topupData?.findIndex((element) => element?.int_price["GBP"] == index);
    return specificIndex >= 0 ? specificIndex : defaultIndex;
  }

  callPromoCF(action: string) {
    if (this.promoName === "autotopup_with_card" || this.promoName === "credit_syndicate_join") {
      this.authService.displayPromo(action, this.promoName);

    }
  }
}
